import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Training_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 Jan 2025",
      name: "Rajesh Kumar",
      designation: "Lab Technician",
      experience: "3 Years",
      qualification: "B.Sc. Chemistry",
      specialization: "Coal Analysis",
      training: "Safety & Handling Training",
      contact: "9876543210",
      email: "rajesh.kumar@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Priya Sharma",
      designation: "Senior Analyst",
      experience: "7 Years",
      qualification: "M.Sc. Environmental Science",
      specialization: "Coal Analysis",
      training: "Proximate & Ultimate Analysis",
      contact: "9876543210",
      email: "priya.sharma@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Amit Verma",
      designation: "Quality Manager",
      experience: "10 Years",
      qualification: "M.Tech Chemical Engineering",
      specialization: "Quality Assurance",
      training: "Internal Auditor Training",
      contact: "9988776655",
      email: "neha.patel@example.com",
      certificate: "PDF",
    },
    {
      date: "12 Jan 2025",
      name: "Priya Sharma",
      designation: "Senior Analyst",
      experience: "7 Years",
      qualification: "M.Sc. Environmental Science",
      specialization: "Coal Analysis",
      training: "Proximate & Ultimate Analysis",
      contact: "9876543210",
      email: "priya.sharma@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Rajesh Kumar",
      designation: "Lab Technician",
      experience: "3 Years",
      qualification: "B.Sc. Chemistry",
      specialization: "Coal Analysis",
      training: "Safety & Handling Training",
      contact: "9876543210",
      email: "rajesh.kumar@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Priya Sharma",
      designation: "Senior Analyst",
      experience: "7 Years",
      qualification: "M.Sc. Environmental Science",
      specialization: "Coal Analysis",
      training: "Proximate & Ultimate Analysis",
      contact: "9876543210",
      email: "priya.sharma@example.com",
      certificate: "PDF",
    },
    {
      date: "12 Jan 2025",
      name: "Amit Verma",
      designation: "Quality Manager",
      experience: "10 Years",
      qualification: "M.Tech Chemical Engineering",
      specialization: "Quality Assurance",
      training: "Internal Auditor Training",
      contact: "9988776655",
      email: "neha.patel@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Priya Sharma",
      designation: "Senior Analyst",
      experience: "7 Years",
      qualification: "M.Sc. Environmental Science",
      specialization: "Coal Analysis",
      training: "Proximate & Ultimate Analysis",
      contact: "9876543210",
      email: "priya.sharma@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Rajesh Kumar",
      designation: "Lab Technician",
      experience: "3 Years",
      qualification: "B.Sc. Chemistry",
      specialization: "Coal Analysis",
      training: "Safety & Handling Training",
      contact: "9876543210",
      email: "rajesh.kumar@example.com",
      certificate: "PDF",
    },
    {
      date: "12 Jan 2025",
      name: "Priya Sharma",
      designation: "Senior Analyst",
      experience: "7 Years",
      qualification: "M.Sc. Environmental Science",
      specialization: "Coal Analysis",
      training: "Proximate & Ultimate Analysis",
      contact: "9876543210",
      email: "priya.sharma@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Amit Verma",
      designation: "Quality Manager",
      experience: "10 Years",
      qualification: "M.Tech Chemical Engineering",
      specialization: "Quality Assurance",
      training: "Internal Auditor Training",
      contact: "9988776655",
      email: "neha.patel@example.com",
      certificate: "PDF",
    },
    {
      date: "03 Jan 2025",
      name: "Rajesh Kumar",
      designation: "Lab Technician",
      experience: "3 Years",
      qualification: "B.Sc. Chemistry",
      specialization: "Coal Analysis",
      training: "Safety & Handling Training",
      contact: "9876543210",
      email: "rajesh.kumar@example.com",
      certificate: "PDF",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Date</th> <th>Name</th> <th>Designation</th>
                <th>Experience</th> <th>Qualification</th>
                <th>Specialization</th> <th>Relevant Training</th>{" "}
                <th>Contact No.</th> <th>Email</th> <th>Certificates</th>{" "}
              </tr>{" "}
            </thead>

            <tbody>
              {paginatedData.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.name}</td>
                  <td>{row.designation}</td>
                  <td>{row.experience}</td>
                  <td>{row.qualification}</td>
                  <td>{row.specialization}</td>
                  <td>{row.training}</td>
                  <td>{row.contact}</td>
                  <td>{row.email}</td>
                  <td>
                    <img
                      src={
                        process.env.PUBLIC_URL + "/assets/images/other/pdf.png"
                      }
                      className="td_img"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Training_Report_Table;
